import React, { useState, useEffect } from "react"
import { Form } from "antd"
import { useParams, useNavigate } from "react-router-dom"
import { useTheme } from "context/AntdThemeContext"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { useDispatch } from "react-redux"
import { setPassword, verifyToken } from "store/confirm-password"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import FirstLoading from "modules/loader-watchers/FirstLoading"
import ConfirmPasswordContent from "./Content"
import PropTypes from "prop-types"
import { toaster } from "components/common/Toast"

const ConfirmPassword = ({ isGuest }) => {
  const [form] = Form.useForm()
  const { token } = useParams()
  const { theme } = useTheme()
  const navigate = useNavigate()

  const [isTokenVerified, setIsTokenVerified] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const dispatch = useDispatch()
  useLoaderWatchers({ watchers: ["confirmPassword"] })

  useEffect(() => {
    if (token) {
      setIsTokenVerified(false)
      setIsSubmitted(false)
      dispatch(verifyToken(token)).then((res) => {
        if (res?.message === "Token is valid") {
          setIsTokenVerified(true)
        }
      })
    }
  }, [token])

  const handleOk = () => {
    form.submit()
  }

  const onFinish = (values) => {
    const payload = {
      token,
      password: values?.password
    }
    dispatch(setPassword(payload)).then((res) => {
      if (res?.message) {
        toaster.success(res.message)
        form.resetFields()
        setIsSubmitted(true)
      }
    })
  }
  return (
    <AuthenticationLayout type="signin" theme={theme}>
      <FirstLoading name="confirmPassword">
        <ConfirmPasswordContent
          isTokenVerified={isTokenVerified}
          isSubmitted={isSubmitted}
          onSignInClick={() => navigate("/auth/sign-in")}
          onSubmit={onFinish}
          onSubmitClick={handleOk}
          form={form}
          isGuest={isGuest}
        />
      </FirstLoading>
    </AuthenticationLayout>
  )
}

ConfirmPassword.propTypes = {
  isGuest: PropTypes.bool
}

ConfirmPassword.defaultProps = {
  isGuest: false
}

export default ConfirmPassword
